import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const ATLAS_INTEGRATION_NAME = 'atlas';
/**
 * Atlas uses a single shared JUST<->Atlas bearer token kept in env
 * (`ATLAS_PARTNER_TOKEN`) -- per-shop credentials are not part of the contract.
 * We still carry an explicit `credentials: {}` object so the shape matches the
 * other integrations in the discriminated union.
 */
export const ZAtlasCredentials = z.object({}).strict();
export const ZAtlasSettings = z.object({}).strict();
export const ZAtlasRate = z.object({
    id: z.string().uuid(),
    provider: z.string(),
    countryCode: z.string(),
    rateNames: z.array(z.string()),
});
export const ZAtlasExternalData = z.object({
    rates: z.array(ZAtlasRate).optional(),
    lastSyncedAt: z.iso.datetime().optional(),
    /**
     * Count of consecutive 401 (UNAUTHORIZED) responses from Atlas. Reset to 0
     * on success and on any non-401 error. After 3 consecutive 401s the sync
     * cron flips the integration to `'inactive'` (merchant must re-activate).
     * Non-401 errors (5xx, network) keep the status at `'error'` but do not
     * accumulate here.
     */
    consecutive401Failures: z.number().int().nonnegative().optional(),
});
export const ZAtlasIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(ATLAS_INTEGRATION_NAME),
    category: z.literal('shipping'),
    credentials: ZAtlasCredentials,
    settings: ZAtlasSettings,
    externalData: ZAtlasExternalData.optional(),
}).shape);
//# sourceMappingURL=atlas.js.map